{
  "appId": "fidj-0123fe7ed0000001",
  "oidcIssuer": "https://api.fidj.ovh/oidc",
  "apiEndpoint": "https://api.fidj.ovh/v3",
  "dashboardUrl": "https://fidj.ovh",
  "title": "Fidj",
  "releaseVersion": "3.27.0",
  "localDemo": false,
  "allowAnonymous": false,
  "signin": "inline",
  "welcome": "One account. Every app. Your choices, with proof.",
  "description": "One place to review your apps, choose what you share, and manage your data.",
  "content": "",
  "highlights": [
    {
      "heading": "See every app",
      "body": "Every app you signed into, what it holds and why."
    },
    {
      "heading": "Switch off what you never wanted",
      "body": "Each change is recorded, app by app, with its history."
    },
    {
      "heading": "Leave and erase",
      "body": "Then follow the request until the app confirms."
    }
  ],
  "badges": [],
  "logo": "./fidj-logo.png",
  "favicon": "./fidj-logo.png",
  "moduleEntry": "#/my",
  "moduleVersion": "3.27.0",
  "moduleLabel": "console",
  "moduleMount": {
    "styles": [
      "/module/styles.2796162af1d2e012.css"
    ],
    "scripts": [
      {
        "src": "/module/runtime.d869e039c17ca40a.js",
        "module": true
      },
      {
        "src": "/module/polyfills.48ee34b9348f526e.js",
        "module": true
      },
      {
        "src": "/module/main.df5134ced2349e16.js",
        "module": true
      }
    ],
    "markup": "<app-root></app-root>"
  }
}
